import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaSitemap } from 'react-icons/fa';
import { Box, Stack, Typography } from '@mui/material';

import ButtonModal from 'src/components/common/ButtonModal';

import FractionDisplay from '../FractionDisplay';

import { styles } from './index.styles';

interface OrgUnitCoverageProps {
  totalCount?: number;
  coveredOrgUnitsCount?: number;
  fractionLabel?: string;
  bigText?: boolean;
}

const OrgUnitCoverage: FC<OrgUnitCoverageProps> = ({
  totalCount = 0,
  coveredOrgUnitsCount = 0,
  fractionLabel = '',
  bigText = false,
}) => {
  const { t } = useTranslation('planAction');

  return (
    <Box>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          mb: 1,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: bigText ? 30 : 20,
          }}
        >
          {t('Statistics.Coverage.CoveredOrgUnits')}
        </Typography>
        <ButtonModal
          headline={t('Statistics.Coverage.CoveredOrgUnits')}
          text={t('Statistics.Coverage.CoveredOrgUnitsHelp')}
        />
      </Stack>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
        }}
      >
        <FractionDisplay
          nominator={coveredOrgUnitsCount}
          denominator={totalCount}
          label={fractionLabel}
          bigText={bigText}
        />
        <Box sx={styles.iconWrapper}>
          <FaSitemap />
        </Box>
      </Stack>
    </Box>
  );
};

export default OrgUnitCoverage;
